export default "__VITE_ASSET__CHGxNPdy__"